import { usPlanData } from './usPlanData'

/**
 * Basketball-specific plan configuration
 * Used across college basketball and women's basketball landing pages
 */
export const getFuboSportsCBBPlans = () => [
  {
    ...usPlanData.fubo_sports_monthly,
    banner: null,
    subtitle: 'College basketball & more sports for less',
    listItems: () => [
      { available: true, text: '25+ channels for sports fans' },
      { available: true, text: 'ACC Network, Big Ten Network, SEC Network' },
      { available: true, text: 'ESPN Unlimited included' },
      { available: true, text: 'NHL, NFL, MLB, NBA' },
      { available: true, text: 'Stream on 10 screens at once' },
      { available: true, text: 'ABC, CBS, FOX' },
      // TEMPORARY NBC DISPUTE
      // { available: false, text: 'NBC, USA Network' },
    ],
    footnoteInCard: null,
  },
  {
    ...usPlanData.pro_monthly,
    subtitle: 'TV for your whole family',
    titleLogo: 'https://assets-imgx.fubo.tv/marketing/lp/images/logos/fubo-pro-logo-2.png',
    promoImg: 'https://assets-imgx.fubo.tv/marketing/lp/images/card/us/pro_plan_card_bg.png',
    networkLogos: null,
    backgroundColor: null,
    listItems: () => [
      { available: true, text: '200+ channels for everyone' },
      { available: true, text: 'ACC Network, Big Ten Network, SEC Network' },
      { available: true, text: 'ESPN Unlimited included' },
      { available: true, text: 'NFL, MLB, NHL, NBA' },
      { available: true, text: 'Stream on 10 screens at once' },
      { available: true, text: 'ABC, CBS, FOX' },
      // TEMPORARY NBC DISPUTE
      // { available: true, text: 'NBC, USA Network' },
    ],
    footnote: (data) =>
      `*$${data.discountedPrice} for month 1, $${data.price}/mo thereafter. Regional restrictions apply. Additional taxes and fees may apply. Prices subject to change.`,
    footnoteInCard: null,
  },
]
